import { render, staticRenderFns } from "./LawDeptlist.vue?vue&type=template&id=476339ab&"
import script from "./LawDeptlist.vue?vue&type=script&lang=js&"
export * from "./LawDeptlist.vue?vue&type=script&lang=js&"
import style0 from "./LawDeptlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports